import { render, staticRenderFns } from "./WordPopover.vue?vue&type=template&id=f832de52&scoped=true&"
import script from "./WordPopover.vue?vue&type=script&lang=js&"
export * from "./WordPopover.vue?vue&type=script&lang=js&"
import style0 from "./WordPopover.vue?vue&type=style&index=0&id=f832de52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f832de52",
  null
  
)

export default component.exports